import React from "react";

import { Area } from "./styles";

interface TextareaProps {
    value: string | null | undefined;
    onChange: (value: string) => void;
    placeholder?: string;
    rows?: number;
    id?: string;
    className?: string;
}

export const Textarea = ({
    value,
    onChange,
    placeholder,
    rows = 4,
    id,
    className,
}: TextareaProps) => (
    <Area
        id={id}
        className={className}
        rows={rows}
        value={value ?? ""}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
    />
);
